document.addEventListener("DOMContentLoaded", function () {
    // Variables for the popup only
    const popup = document.getElementById('countryPopup');
    if (!popup) return; // Exit if popup doesn't exist

    const continueBtn = document.getElementById('countryPopupContinue');
    const selectedCountryEl = document.getElementById('selectedCountry');
    const selectedLanguageEl = document.getElementById('selectedLanguage');
    const countryDropdownBtn = popup.querySelector('#countryDropdown');
    const languageDropdownBtn = popup.querySelector('#languageDropdown');
    const countryDropdownMenu = popup.querySelector('.country-popup__countries');
    const languageDropdownMenu = popup.querySelector('.language-selector .custom-dropdown-menu');

    let selectedCountry = 'global';
    let selectedCountryName = 'Global';
    let selectedLanguageLink = null;

    // Initialize custom dropdown menus to be hidden
    const allDropdownMenus = popup.querySelectorAll('.custom-dropdown-menu');
    allDropdownMenus.forEach(menu => {
        menu.style.display = 'none';
    });

    // Check if cookie exists - if it does, don't show popup
    function checkCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }

    // If country cookie exists, don't show popup
    if (checkCookie('era_country_pref')) {
        return;
    }

    // Show the popup
    popup.classList.add('is-active');

    // Set up country dropdown
    if (countryDropdownBtn && countryDropdownMenu) {
        // Set up initial country selection if available
        const countryLinks = countryDropdownMenu.querySelectorAll('.country-switcher-link-popup');
        if (countryLinks.length > 0) {
            const firstCountry = countryLinks[0];
            selectedCountry = firstCountry.dataset.country || 'global';
            selectedCountryName = firstCountry.dataset.countryName || firstCountry.textContent.trim();
            if (selectedCountryEl) {
                selectedCountryEl.textContent = selectedCountryName;
            }
        }

        // Toggle country dropdown on button click
        countryDropdownBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Simple toggle - if it has custom-open class, remove it; otherwise add it
            if (countryDropdownMenu.classList.contains('custom-open')) {
                countryDropdownMenu.classList.remove('custom-open');
                countryDropdownMenu.style.display = 'none';
            } else {
                // Close language dropdown if open
                languageDropdownMenu.classList.remove('custom-open');
                languageDropdownMenu.style.display = 'none';

                // Open country dropdown
                countryDropdownMenu.classList.add('custom-open');
                countryDropdownMenu.style.display = 'block';
            }
        });

        // Handle country selection
        countryLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                selectedCountry = this.dataset.country || 'global';
                selectedCountryName = this.dataset.countryName || this.textContent.trim();

                if (selectedCountryEl) {
                    selectedCountryEl.textContent = selectedCountryName;
                }

                // Close the dropdown
                countryDropdownMenu.classList.remove('custom-open');
                countryDropdownMenu.style.display = 'none';
            });
        });
    }

    // Set up language dropdown
    if (languageDropdownBtn && languageDropdownMenu) {
        // Toggle language dropdown on button click
        languageDropdownBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Simple toggle - if it has custom-open class, remove it; otherwise add it
            if (languageDropdownMenu.classList.contains('custom-open')) {
                languageDropdownMenu.classList.remove('custom-open');
                languageDropdownMenu.style.display = 'none';
            } else {
                // Close country dropdown if open
                countryDropdownMenu.classList.remove('custom-open');
                countryDropdownMenu.style.display = 'none';

                // Open language dropdown
                languageDropdownMenu.classList.add('custom-open');
                languageDropdownMenu.style.display = 'block';
            }
        });

        // Handle language selection
        const languageLinks = languageDropdownMenu.querySelectorAll('.dropdown-menu__item-link');
        languageLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                // Store this link for later use
                selectedLanguageLink = this;

                // Store original href
                if (!this.dataset.originalHref) {
                    this.dataset.originalHref = this.href;
                }

                // Update selected language text
                if (selectedLanguageEl) {
                    selectedLanguageEl.textContent = this.textContent.trim();
                }

                // Close the dropdown
                languageDropdownMenu.classList.remove('custom-open');
                languageDropdownMenu.style.display = 'none';
            });
        });
    }

    // Handle clicks outside dropdowns to close them
    document.addEventListener('click', function (e) {
        // Only if popup is active and click is inside the popup
        if (!popup.classList.contains('is-active') || !popup.contains(e.target)) {
            return;
        }

        // Close country dropdown if click is outside it
        if (countryDropdownMenu && countryDropdownBtn &&
            countryDropdownMenu.classList.contains('custom-open') &&
            !countryDropdownBtn.contains(e.target) &&
            !countryDropdownMenu.contains(e.target)) {
            countryDropdownMenu.classList.remove('custom-open');
            countryDropdownMenu.style.display = 'none';
        }

        // Close language dropdown if click is outside it
        if (languageDropdownMenu && languageDropdownBtn &&
            languageDropdownMenu.classList.contains('custom-open') &&
            !languageDropdownBtn.contains(e.target) &&
            !languageDropdownMenu.contains(e.target)) {
            languageDropdownMenu.classList.remove('custom-open');
            languageDropdownMenu.style.display = 'none';
        }
    });

    // Map country to language
    function mapCountryToLanguage(countryCode) {
        const map = {
            'netherlands': 'nl',
            'germany': 'de',
            'switzerland': 'de',
            'spain': 'es',
            'france': 'fr',
            'italy': 'it',
            'uk': 'en',
            'global': 'en'
        };
        return map[countryCode?.toLowerCase()] || 'en';
    }

    // Map country/language to flag URL (hardcoded for reliability)
    function getFlagUrl(countryOrLanguage) {
        const code = (countryOrLanguage || '').toLowerCase();
        const baseUrl = '/wp-content/plugins/sitepress-multilingual-cms/res/flags/';

        const flagMap = {
            'nl': baseUrl + 'nl.png',
            'netherlands': baseUrl + 'nl.png',
            'de': baseUrl + 'de.png',
            'germany': baseUrl + 'de.png',
            'ch': baseUrl + 'ch.png',
            'switzerland': baseUrl + 'ch.png',
            'es': baseUrl + 'es.png',
            'spain': baseUrl + 'es.png',
            'en': baseUrl + 'en.png',
            'uk': baseUrl + 'en.png',
            'fr': baseUrl + 'fr.png',
            'france': baseUrl + 'fr.png',
            'it': baseUrl + 'it.png',
            'italy': baseUrl + 'it.png',
            'global': null // Will use SVG globe
        };

        return flagMap[code] || null;
    }

    // Set language cookie
    function setLanguageCookie(language) {
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        deleteCookieEverywhere('wp-wpml_current_language');
        document.cookie = `wp-wpml_current_language=${language}; expires=${expirationDate.toUTCString()}; path=/; secure; samesite=Lax;`;
    }

    // Set flag URL cookie
    function setFlagUrlCookie(flagUrl) {
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        deleteCookieEverywhere('eraneos_flag_url');
        document.cookie = `eraneos_flag_url=${encodeURIComponent(flagUrl)}; expires=${expirationDate.toUTCString()}; path=/; secure; samesite=Lax;`;
    }

    // Handle continue button click
    if (continueBtn) {
        continueBtn.addEventListener('click', function () {
            // Determine language for the event
            const language = selectedLanguageLink ?
                (selectedLanguageLink.dataset.language || mapCountryToLanguage(selectedCountry)) :
                mapCountryToLanguage(selectedCountry);

            // Get flag URL from hardcoded mapping (more reliable than DOM extraction)
            const flagUrl = getFlagUrl(selectedCountry);

            // Set BOTH country AND language cookies
            setCountryCookie(selectedCountry);
            setLanguageCookie(language);

            // Store flag URL in cookie so it's available on page load
            if (flagUrl) {
                setFlagUrlCookie(flagUrl);
            } else {
                // Global option - store 'global' so we know to show globe
                setFlagUrlCookie('global');
            }

            // Fire custom event for immediate UI updates
            try {
                const event = new CustomEvent('countryPreferenceChanged', {
                    detail: { country: selectedCountry, language: language, flagUrl: flagUrl }
                });
                document.dispatchEvent(event);
            } catch (_) {
                // noop
            }

            // Close popup
            popup.classList.remove('is-active');

            // Add small delay to ensure cookies are written before redirect
            setTimeout(function () {
                // If a language was specifically selected, navigate to that URL
                if (selectedLanguageLink && selectedLanguageLink.dataset.originalHref) {
                    const href = selectedLanguageLink.dataset.originalHref;
                    try {
                        const url = new URL(href, window.location.origin);
                        url.searchParams.set('country', selectedCountry);
                        window.location.href = url.toString();
                    } catch (e) {
                        const sep = href.includes('?') ? '&' : '?';
                        window.location.href = `${href}${sep}country=${encodeURIComponent(selectedCountry)}`;
                    }
                } else {
                    // Just reload the page (the cookie will be used for country) but include country param to normalize
                    try {
                        const url = new URL(window.location.href);
                        url.searchParams.set('country', selectedCountry);
                        window.location.href = url.toString();
                    } catch (e) {
                        const sep = window.location.href.includes('?') ? '&' : '?';
                        window.location.href = `${window.location.href}${sep}country=${encodeURIComponent(selectedCountry)}`;
                    }
                }
            }, 100); // 100ms delay to ensure cookies are written
        });
    }

    // Set country cookie
    function getAncestorPaths() {
        try {
            const parts = window.location.pathname.split('/').filter(Boolean);
            const paths = ['/'];
            let accum = '';
            for (const part of parts) {
                accum += '/' + part;
                paths.push(accum + '/');
            }
            return Array.from(new Set(paths));
        } catch (e) {
            return ['/'];
        }
    }

    function deleteCookieEverywhere(name) {
        const expireDate = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
        const host = window.location.hostname;
        const paths = getAncestorPaths();
        for (const path of paths) {
            document.cookie = `${name}=; ${expireDate}; path=${path}; secure; samesite=Lax`;
            document.cookie = `${name}=; ${expireDate}; path=${path}; domain=${host}; secure; samesite=Lax`;
            const hostParts = host.split('.');
            if (hostParts.length > 2) {
                const baseDomain = hostParts.slice(-2).join('.');
                document.cookie = `${name}=; ${expireDate}; path=${path}; domain=.${baseDomain}; secure; samesite=Lax`;
            }
        }
    }

    function setCountryCookie(country) {
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        deleteCookieEverywhere('era_country_pref');
        document.cookie = `era_country_pref=${country}; expires=${expirationDate.toUTCString()}; path=/; secure; samesite=Lax;`;
    }
}); 